/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAnforderungStandortErfuellungDto } from '../../models/lexplus-anforderung-standort-erfuellung-dto';
import { LexplusUpdateAnforderungVerantwortlicheFunktionDto } from '../../models/lexplus-update-anforderung-verantwortliche-funktion-dto';

export interface AnforderungenControllerUpdateVerantwortlicheFunktionV1$Params {
  anforderungsversionID: number;
  standortID: number;
      body: LexplusUpdateAnforderungVerantwortlicheFunktionDto
}

export function anforderungenControllerUpdateVerantwortlicheFunktionV1(http: HttpClient, rootUrl: string, params: AnforderungenControllerUpdateVerantwortlicheFunktionV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAnforderungStandortErfuellungDto>> {
  const rb = new RequestBuilder(rootUrl, anforderungenControllerUpdateVerantwortlicheFunktionV1.PATH, 'patch');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
    rb.path('standortID', params.standortID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAnforderungStandortErfuellungDto>;
    })
  );
}

anforderungenControllerUpdateVerantwortlicheFunktionV1.PATH = '/v1/anforderungen/{anforderungsversionID}/standorte/{standortID}/verantwortliche-funktion';
